import React from 'react';
import UIStrings from '@/Utils/UIStrings';

interface DialogCardRejectTitleProps {
    name: string;
}

function DialogCardRejectTitle({ name }: DialogCardRejectTitleProps): React.JSX.Element {
    return (
        <div className="text-foreground text-lg font-bold">{`${UIStrings.RejectApplicantDialogHeader1} ${name}`}</div>
    );
}

export default DialogCardRejectTitle;
